/* XECAR · Megamenú: abre con hover en escritorio; clic, teclado y Escape siguen funcionando (Dawn). */
(() => {
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const bind = () => {
    document.querySelectorAll('[data-xe-mega]').forEach((details) => {
      if (details.dataset.xeBound) return;
      details.dataset.xeBound = '1';
      const item = details.closest('.xe-nav__item') || details;
      const summary = details.querySelector('summary');
      let timer;
      item.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        clearTimeout(timer);
        document.querySelectorAll('[data-xe-mega][open]').forEach((d) => { if (d !== details) d.removeAttribute('open'); });
        if (!details.open) details.setAttribute('open', '');
        summary?.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', () => {
        if (!desktop.matches) return;
        timer = setTimeout(() => {
          details.removeAttribute('open');
          summary?.setAttribute('aria-expanded', 'false');
        }, 180);
      });
      details.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && details.open) { details.removeAttribute('open'); summary?.focus(); }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();

/* Al pasar por cada marca, cambia la foto de la derecha */
(() => {
  const bind = () => {
    document.querySelectorAll('[data-xe-photos]').forEach((stack) => {
      if (stack.dataset.xeBound) return;
      stack.dataset.xeBound = '1';
      const panel = stack.closest('.xe-mega__inner') || stack.parentElement;
      const show = (i) => stack.querySelectorAll('[data-xe-shot]').forEach((a) => a.classList.toggle('is-active', a.dataset.xeShot === i));
      panel.querySelectorAll('[data-xe-photo]').forEach((col) => {
        const i = col.dataset.xePhoto;
        col.addEventListener('mouseenter', () => show(i));
        col.addEventListener('focusin', () => show(i));
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();
